<template>
  <v-card>
    <v-card-title class="header-title">
      🔍 Results related to 
      <span class="highlight">"{{ querySearch }}"</span>
    </v-card-title>
    <v-card-title class="bg-blue">
      Companies
    </v-card-title>
    <PanelCompanies
      :page="pageCompanys"
      :length="totalPagesCompanys"
      :companies="listCompanies"
      @onPageChange="changePageCompany"
    />
    <v-card-title class="bg-blue">
      Products
    </v-card-title>
    <PanelProducts
      :page="pageProducts"
      :length="totalPagesProducts"
      :products="listProducts"
      @onPageChange="onPageChangeProducts"
    />
  </v-card>
</template>
<script>
import apisProduct from "@/apis/apisProducts";
import apisCompany from "@/apis/apisCompanys";
import PanelCompanies from '@/components/PanelCompanies.vue';
import PanelProducts from '@/components/PanelProducts.vue'

export default {
  name: 'SearchView',
  components: {
    PanelCompanies,
    PanelProducts
  },
  data() {
    return {
      querySearch: this.$route.params.query || '',
      listProducts: [],
      pageProducts: 1,
      totalPagesProducts: null,
      listCompanies: [],
      pageCompanys: 1,
      totalPagesCompanys: null,

    };
  },
  created() {
    this.changePageCompany(this.pageCompanys)
    this.onPageChangeProducts(this.pageCompanys)
  },
  methods: {
    changePageCompany(page){
      apisCompany.search(this.querySearch,"","",page - 1)
        .then(companies => {
          this.listCompanies = companies.content
          this.totalPagesCompanys = companies.totalPages
          this.pageCompanys = companies.pageNumber  + 1; 
        })
    },
    onPageChangeProducts(page){
      apisProduct.search(this.querySearch,this.querySearch,this.querySearch, page - 1)
        .then(products => {
          this.listProducts = products.content
          this.totalPagesProducts = products.totalPages
          this.pageProducts = products.pageNumber  + 1
        })
    }
  }
}
</script>
<style scoped>
.card-products{
  display: flex;
  flex-direction: row;
  flex-wrap:wrap;
  gap: 20px;
  justify-content: center;
  padding: 10px;
  background: linear-gradient(135deg, #908aff, #d1d8e4, #38d8f5);
}
.header-title {
  background: linear-gradient(135deg, #102b65, #1e3a8a);
  color: #fff;
  font-weight: 600;
  font-size: 1.3rem;
  padding: 16px;
  text-align: center;
  border-bottom: 1px solid rgba(255,255,255,0.1);
  letter-spacing: 0.5px;
}
.ComponentProduct{
  height: 400px;
  padding: 10px;
  width: 22%;
}

.card-companies{
  display: flex;
  flex-direction: row;
  flex-wrap:wrap;
  gap: 20px;
  justify-content: center;
  padding: 10px;
  background: linear-gradient(135deg, #908aff, #d1d8e4, #38d8f5);
}

.ComponentCompany{
  margin-left: 15px;
  height: auto;
  max-height: 1200px;
  width: 48%;
}

</style>